(function () {
  'use strict';

  angular.module('app').component('clientProfilePage', clientProfileDetailComponent());

  function clientProfileDetailComponent() {
    return {
      controller: ClientProfileDetailCtrl,
      controllerAs: 'vm',
      bindings: {},
      templateUrl: './app/ajs/client-profiles/client-profile-page.component.html',
    };
  }

  ClientProfileDetailCtrl.$inject = [
    '$location',
    '$routeParams',
    'AbilityService',
    'ClientProfileService',
  ];

  function ClientProfileDetailCtrl($location, $routeParams, AbilityService, ClientProfileService) {
    var vm = this;

    vm.permissions = {
      canCreate: AbilityService.can('create_clientprofile_accountadmin'),
    };

    var itemId = $routeParams.id;

    vm.onClientProfileSaved = onClientProfileSaved;
    vm.onClientProfileCanceled = onClientProfileCanceled;

    // Initializers
    getItem();

    function getItem() {
      if (itemId) {
        // edit
        vm.loadingItem = true;
        ClientProfileService.getClientProfile(itemId).then(function (data) {
          vm.item = data;

          vm.loadingItem = false;
        });
      } else {
        vm.item = {};
      }
    }

    function onClientProfileSaved(item) {
      $location.path(`/client_profiles/${item.id}`);
    }

    function onClientProfileCanceled() {
      $location.path('/client_profiles');
    }
  }
})();
